module.exports = __webpack_public_path__ + "static/media/blog.10a36261.png";